import fallbackImage from '../img/news-fallback.svg';

const IMAGE_FIELDS = [
  'thumbnailURL',
  'thumbnail',
  'imageUrl',
  'imageURL',
  'image',
  'mainImage',
  'cover',
  'parsedImage',
];

export const normalizeImageSource = (value) => {
  const source = typeof value === 'string' ? value.trim() : '';
  if (!source) return null;
  if (
    process.env.NODE_ENV === 'production'
    && /^(?:https?:\/\/)?(?:localhost|127\.0\.0\.1)(?:[:/]|$)/i.test(source)
  ) {
    return null;
  }
  if (/^http:\/\//i.test(source)) return null;
  if (/^(https:\/\/|\/|data:image\/|blob:)/i.test(source)) return source;
  return null;
};

export const resolveNewsImage = (news, fallbackSrc = fallbackImage) => {
  if (typeof news === 'string') {
    return normalizeImageSource(news) || fallbackSrc;
  }

  for (const field of IMAGE_FIELDS) {
    const source = normalizeImageSource(news?.[field]);
    if (source) return source;
  }

  return normalizeImageSource(news?.media?.url) || fallbackSrc;
};

export { fallbackImage as NEWS_IMAGE_FALLBACK };

